import { baseURL } from "./axios";


export default (url: string, config: object): Promise<object> => {
  return fetch(`${baseURL()}${url}`, { ...config });
};
